import {ENDPOINT_USER} from 'common/endpoints';
import _ from 'lodash';
import {commonJwtHeader} from 'common/utils';

// gets extremely limited info for all entities this user has permissions for (id + name essentially)
const getEntities = (token) => {
  return fetch(`${ENDPOINT_USER}entity`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getManagedEntities = (token) => {
  return fetch(`${ENDPOINT_USER}entity/managed`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

// Gets names, emails etc for users specified in request body by userids
const getProfilesForUsers = (token, body) => {
  return fetch(`${ENDPOINT_USER}users/`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};

const getRegisteredUser = (token, email) => {
  return fetch(`${ENDPOINT_USER}${encodeURIComponent(email)}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};
const getRegisteredUserRole = (email, entityTypeId, entityId, roleId) => {
  return fetch(
    `${ENDPOINT_USER}${encodeURIComponent(
      email
    )}/role/${roleId}?entityTypeId=${entityTypeId}&entityId=${entityId}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getOrgUser = (token, orgId) => {
  return fetch(`${ENDPOINT_USER}team?entityId=${orgId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

// prefer this over the more specific ones below
const getTeamList = (token, queryParams) => {
  const queryString = _.join(
    _.map(queryParams, (value, key) => `${key}=${value}`),
    '&'
  );
  const endpointToUse = `${ENDPOINT_USER}team/teamlist${
    queryString ? '?' + queryString : ''
  }`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAorList = (token, organizationId, programId) => {
  return fetch(
    `${ENDPOINT_USER}entity/aor?entityId=${organizationId}&programId=${programId}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

// prefer this over the more specific ones below
const getEntityTeamList = (token, queryParams) => {
  const queryString = _.join(
    _.map(queryParams, (value, key) => `${key}=${value}`),
    '&'
  );
  const endpointToUse = `${ENDPOINT_USER}entity/teamlist${
    queryString ? '?' + queryString : ''
  }`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getEntityTeamListByParentId = (token, parentEntityId, entityId) => {
  return getEntityTeamList(token, {parentEntityId, entityId});
};

const getTeamListByParentId = (token, parentEntityId, entityId) => {
  return getTeamList(token, {parentEntityId, entityId});
};

const getPocListEntityByParentId = (token, parentOrgId, organizationId, toggle) => {
  if (toggle) {
    return getEntityTeamList(token, {
      parentEntityId: parentOrgId,
      entityId: organizationId,
    });
  } else {
    return getTeamList(token, {entityId: organizationId});
  }
};

const getSubOrgPoc = (token, parentOrgId, organizationId) => {
  return fetch(
    `${ENDPOINT_USER}entity/poc?parentEntityId=${parentOrgId}&entityId=${organizationId}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getOrgProfileData = (token) => {
  return fetch(`${ENDPOINT_USER}team/`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getManageableTeamMembers = () => {
  return fetch(`${ENDPOINT_USER}teamManagement/`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getRolesICanAssign = () => {
  return fetch(`${ENDPOINT_USER}rolesICanAssign/`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAllRolesByEmailAdr = (emailAdr) => {
  return fetch(
    `${ENDPOINT_USER}teamManagement/${encodeURIComponent(emailAdr)}/allRoles`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const searchAssignablePermissions = (permissions) => {
  return fetch(`${ENDPOINT_USER}searchAssignablePermissions`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify({
      permissions,
    }),
  });
};

const manageUserRoles = (emailAdr, toAdd, toDelete) => {
  return fetch(`${ENDPOINT_USER}teamManagement/${encodeURIComponent(emailAdr)}/roles`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify({
      add: toAdd,
      delete: toDelete,
    }),
  });
};

const getRoles = (token) => {
  return fetch(`${ENDPOINT_USER}role/`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const removeRole = (token, body, queryParams) => {
  const queryString = _.join(
    _.map(queryParams, (value, key) => `${key}=${value}`),
    '&'
  );
  const endpointToUse = `${ENDPOINT_USER}team/${queryString ? '?' + queryString : ''}`;
  return fetch(endpointToUse, {
    method: 'DELETE',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};

const addRole = (token, body) => {
  return fetch(`${ENDPOINT_USER}team/`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};

const modifyUserRoles = (token, userId, body) => {
  return fetch(`${ENDPOINT_USER}${encodeURIComponent(userId)}/roles`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};

const getParentEntities = (token) => {
  return fetch(`${ENDPOINT_USER}entity/parent`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getManagedAnalyticsRoles = (token) => {
  return getManagedEntities(token);
};

const getAnalyticsRoles = (token) => {
  return getRoles(token);
};

const getSignatureTitleInfo = (emailAdr) => {
  return fetch(
    `${ENDPOINT_USER}teamManagement/${encodeURIComponent(emailAdr)}/signatureTitleInfo`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const modifySignature = (signatureTitleInfo) => {
  return fetch(`${ENDPOINT_USER}teamManagement/modifySignature`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(signatureTitleInfo),
  });
};

const getRegisteredUserByEmail = (emailAdr) => {
  return fetch(`${ENDPOINT_USER}email/${encodeURIComponent(emailAdr)}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getUser = ({token, userId}) => {
  return getRegisteredUser(token, userId);
};

export default {
  getEntities,
  getManagedEntities,
  getProfilesForUsers,
  getRegisteredUser,
  getRegisteredUserRole,
  getRegisteredUserByEmail,
  getOrgUser,
  getTeamList,
  getEntityTeamList,
  getSubOrgPoc,
  getEntityTeamListByParentId,
  getTeamListByParentId,
  getPocListEntityByParentId,
  getOrgProfileData,
  getManageableTeamMembers,
  getRolesICanAssign,
  getAllRolesByEmailAdr,
  manageUserRoles,
  searchAssignablePermissions,
  getRoles,
  removeRole,
  addRole,
  modifyUserRoles,
  getParentEntities,
  getManagedAnalyticsRoles,
  getAnalyticsRoles,
  getSignatureTitleInfo,
  modifySignature,
  getAorList,
  getUser,
};
